export enum CommandStatusEnum {
  CommandWaitingForDeliver = 'commandWaitingForDeliver',
  CommandReceivedAndUpdated = 'commandReceivedAndUpdated',
  CommandFailedToUpdate = 'commandFailedToUpdate',
  CommandFailedTimeOut = 'commandFailedTimeOut',
  CommandFailedOffline = 'commandFailedOffline',
  CommandIgnoredUnchangedValue = 'commandIgnoredUnchangedValue',
}
